import * as Sentry from '@sentry/nextjs'
import { isDevEnvironment } from './envUtils'

const sendLog = (logData: string | Error) => {
  const isServer = typeof window === 'undefined'

  if (typeof logData === 'string' && (isDevEnvironment() || isServer)) {
    console.log(logData)
  }

  if (logData instanceof Error) {
    if (isServer) {
      console.error(logData)
    }

    Sentry.captureException(logData)
  }
}

export default sendLog
